export function parseBreadcrumbHref(href: string): string[] {
  const hashPath = href.startsWith('#') ? href.slice(1) : href
  return hashPath ? hashPath.split('/') : []
}
